import { ExposureConstants } from './exposure.constants'
import { IExposuresAction, IExposureState } from './exposure.types'

export const initialExposure = {
  crewId: 0,
  exposureEquipment: [],
  suspectedExposure: null,
  suspectedExposurePNNV: null,
  exposureType: [],
  exposureTypePNNV: null,
  exposedTo: null,
}

export const initialExposureState: IExposureState = {
  crewId: 0,
  exposureEquipment: [],
  suspectedExposure: null,
  suspectedExposurePNNV: null,
  exposureType: [],
  exposureTypePNNV: null,
  exposedTo: null,
  exposure: null,
  exposureList: [],
  crewList: [],
}

export function exposureReducer(
  state: IExposureState = initialExposureState,
  action: IExposuresAction
): IExposureState {
  switch (action.type) {
    case ExposureConstants.SET_EXPOSURE_LIST:
      return {
        ...state,
        exposureList: action.exposureList,
      }
    case ExposureConstants.SET_EXPOSURE:
      return {
        ...state,
        exposure: action.exposure,
      }
    case ExposureConstants.SET_CREW_ID:
      return {
        ...state,
        crewId: action.crewId,
      }
    case ExposureConstants.SET_EXPOSURE_EQUIPMENT:
      return {
        ...state,
        exposureEquipment: action.exposureEquipment,
        crewId: action.crewId,
      }
    case ExposureConstants.SET_EXPOSURE_TYPE:
      return {
        ...state,
        exposureType: action.exposureType,
        crewId: action.crewId,
      }
    case ExposureConstants.SET_EXPOSURE_TYPE_PNNV:
      return {
        ...state,
        exposureTypePNNV: action.exposureTypePNNV,
      }
    case ExposureConstants.SET_EXPOSED_TO:
      return {
        ...state,
        exposedTo: action.exposedTo,
        crewId: action.crewId,
      }
    case ExposureConstants.SET_SUSPECTED_EXPOSURE:
      return {
        ...state,
        suspectedExposure: action.suspectedExposure,
        suspectedExposurePNNV: null,
        crewId: action.crewId,
      }
    case ExposureConstants.SET_SUSPECTED_EXPOSURE_PNNV:
      return {
        ...state,
        suspectedExposurePNNV: action.suspectedExposurePNNV,
        crewId: action.crewId,
      }
    case ExposureConstants.SET_CREW_LIST:
      return { ...state, crewList: action.crewList }
    case ExposureConstants.SET_EXPOSURE_STATE:
      return { ...action.exposureState }
    case ExposureConstants.RESET_STATE:
      return {
        crewId: 0,
        exposureEquipment: [],
        suspectedExposure: null,
        suspectedExposurePNNV: null,
        exposureType: [],
        exposureTypePNNV: null,
        exposedTo: null,
        exposure: null,
        exposureList: [],
        crewList: [],
      }
    default:
      return state
  }
}
